import i18n, { InitOptions } from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import * as utils from "./utils";

export const getCookieDomain = utils.getCookieDomain;

export default function initI18n(options: InitOptions) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      debug: process.env.NODE_ENV === "development",
      fallbackLng: "en",
      keySeparator: ".",
      interpolation: {
        escapeValue: false,
      },
      ns: ["common"],
      defaultNS: "common",
      detection: {
        order: ["cookie"],
        lookupCookie: "i18n",
        caches: ["cookie"],
        cookieMinutes: 60 * 24 * 365,
        cookieDomain: getCookieDomain(),
        cookieOptions: { path: "/", sameSite: "", secure: process.env.NODE_ENV === "production" },
      },
      ...options,
    });
}
